'use strict';

import template from '../../templates/mppAccounts/Main.ejs';
import AddTpl from '../../templates/mppAccounts/Add.ejs';
import User from 'newModels/user.js';
import AccountView from './Account';
import Loader from 'helpers/loader';
import Alerts from 'lib/alerts';

module.exports = Backbone.View.extend({
    events: {
        'click .js-save': 'save',
        'input .js-email': 'onEmailChange'
    },

    initialize: function(options) {
        this.options = _.defaults(options || {}, {
            discountCodes: []
        });
        return this;
    },

    save: function(ev) {
        const stopLoader = Loader.startFullScreen(ev.currentTarget);
        const email = this.$('.js-email').val();
        const name = this.$('.js-name').val();

        User.inviteMppAdmin(name, email)
            .then(() => {
                stopLoader();
                this.$('#add-modal').modal('hide');
                return Alerts.show('success', {
                    title: 'MPP Invitation',
                    text: 'Invitation successfully sent!'
                });
            })
            .catch(err => {
                stopLoader();
                this.$('#add-modal').modal('hide');
                return Alerts.show('error', {
                    title: 'MPP Invitation not sent',
                    text: err
                });
            });
    },

    onEmailChange: function() {
        if (this.$('.js-email').val()) {
            this.$('.js-save').prop('disabled', false);
        } else {
            this.$('.js-save').prop('disabled', true);
        }
    },

    render: function() {
        this.$el.html(template({
            collection: this.collection,
            addModal: AddTpl()
        }));

        let $container = this.$('.js-accounts');
        this.collection.forEach(mppAccount => {
            let view = new AccountView({
                model: mppAccount,
                discountCodes: this.options.discountCodes
            });
            $container.append(view.$el);
        });
        return this;
    }
});



// WEBPACK FOOTER //
// ./app/adminManager/views/mppAccounts/Main.js